import { Injectable } from '@angular/core';

import { BasicVerificationStatus } from '../models/verification-profile-response';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class VerificationNavigatorService {
  constructor(private _router: Router) {
  }

  getVerificationUrlByStatus(status: BasicVerificationStatus | null): string[] {
    switch (status) {
      case BasicVerificationStatus.basicFormPassed:
        return ['profile/verification/express'];
      case BasicVerificationStatus.accepted:
      case BasicVerificationStatus.trial:
        return ['/profile/verification/identity'];
      default:
        return ['/profile/verification/route'];
    }
  }

  navigateToVerificationByStatus(status: BasicVerificationStatus | null): void {
    void this._router.navigate(this.getVerificationUrlByStatus(status));
  }
}
